import { useReveal } from "@/lib/useReveal";

const IMAGES = [
    // Rearranged so cellar/lifestyle/vineyard shots alternate and similar photos are not adjacent
    { src: "https://i.ibb.co/FvdxRqF/trokay-13.jpg", h: "h-[440px] md:h-[600px]" },
    { src: "https://i.ibb.co/dwkqFnGM/trokay-43.jpg", h: "h-[300px] md:h-[380px]" },
    { src: "https://i.ibb.co/0jx2J3Yf/trokay-26.jpg", h: "h-[260px] md:h-[320px]" },
    { src: "https://i.ibb.co/pvDrmyH0/trokay-36.jpg", h: "h-[320px] md:h-[460px]" },
    { src: "https://i.ibb.co/4w0Cr5kc/trokay-17.jpg", h: "h-[280px] md:h-[360px]" },
    { src: "https://i.ibb.co/BK360Vmh/trokay-42.jpg", h: "h-[300px] md:h-[400px]" },
    { src: "https://i.ibb.co/rLmqdy2/trokay-27.jpg", h: "h-[260px] md:h-[320px]" },
    { src: "https://i.ibb.co/nNP4nWjz/trokay-45.jpg", h: "h-[320px] md:h-[440px]" },
    { src: "https://i.ibb.co/Fb2K46dK/trokay-48.jpg", h: "h-[280px] md:h-[360px]" },
];

export default function Gallery() {
    const { ref, visible } = useReveal(0.05);
    return (
        <section
            ref={ref}
            id="galerie"
            data-testid="gallery-section"
            className="py-24 md:py-36 px-6 md:px-12 bg-cream"
        >
            <div className="mx-auto max-w-[1500px]">
                <div className={`grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 items-end transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                    <div className="lg:col-span-7">
                        <p className="overline mb-6">Galerie · Vinice · Sklep · Život ve vinařství</p>
                        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-ink">
                            Ze <span className="font-serif-italic text-burgundy">života vinařství</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-base md:text-lg text-ink2 leading-relaxed lg:max-w-md">
                        Pohled do vinice, do sklepa a mezi lidi, se kterými si naše víno rádi připíjíme.
                    </p>
                </div>

                <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5 [column-fill:_balance]">
                    {IMAGES.map((img, i) => (
                        <div
                            key={img.src}
                            data-testid={`gallery-image-${i}`}
                            className={`image-hover overflow-hidden mb-4 md:mb-5 break-inside-avoid transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
                            style={{ transitionDelay: `${i * 60}ms` }}
                        >
                            <img
                                src={img.src}
                                alt=""
                                loading="lazy"
                                className={`w-full ${img.h} object-cover`}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
